import { Editor } from '@tiptap/core';
import { StarterKit } from '@tiptap/starter-kit';
import { TaskItem, TaskList } from '@tiptap/extension-list';
import { TextAlign } from '@tiptap/extension-text-align';
import { Highlight } from '@tiptap/extension-highlight';
import { Markdown } from 'tiptap-markdown';

/**
 * Convert HTML content to Markdown using TipTap
 */
export function htmlToMarkdown(html: string): string {
  try {
    // Configure the same extensions used in the editor
    const extensions = [
      StarterKit.configure({
        horizontalRule: false,
      }),
      TextAlign.configure({ types: ['heading', 'paragraph'] }),
      TaskList,
      TaskItem.configure({ nested: true }),
      Highlight.configure({ multicolor: true }),
      Markdown,
    ];
    
    // Create a temporary editor instance
    const tempEditor = new Editor({
      extensions,
      content: html,
    });
    
    // Get markdown from the editor
    const markdown = tempEditor.storage.markdown.getMarkdown();
    tempEditor.destroy();
    
    return markdown;
  } catch (error) {
    console.error('Error converting HTML to Markdown:', error);
    // Fallback: strip HTML tags and return plain text
    return html.replace(/<[^>]*>/g, '').trim();
  }
}
